import React from 'react'
import { Form, Input, Button, Modal, InputNumber, Switch, Radio, Tabs, Icon, Tooltip } from 'antd'
import CryptoJS from 'crypto-js'
import config from '../../config/index'
import PhoneInputComponent from '../../components/PhoneInputComponent'
import PhonePrefixMultiselect from '../../components/PhonePrefixMultiselect'

const FormItem = Form.Item
const { TextArea } = Input
const { TabPane } = Tabs

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
    this.handleOnDelete = this.handleOnDelete.bind(this)
    this.state = {
      activeKeyTab: '1',
      errorPhoneNumber: false,
    }
  }

  handleOnSubmit(e) {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll({ force: true }, (err, values) => {
      if (err) {
        return
      }
      this.props.onSubmit(values)
    })
  }

  handleOnDelete(e) {
    e.preventDefault()
    const handleOnOk = () => {
      this.props.onDelete()
    }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      okType: 'danger',
      okText: 'Да',
      cancelText: 'Нет',
      onOk() {
        handleOnOk()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const isEPO = localStorage.getItem('isEPO') === '1'
    const { paramList } = this.props
    const {
      getFieldDecorator,
    } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 10 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 12,
          offset: 7,
        },
      },
    }
    const isCreateForm = this.props.type === 'create'

    return (
      <Form onSubmit={this.handleOnSubmit}>
        {!isEPO ?
          <Tabs defaultActiveKey='1' onChange={(e) => this.setState({ activeKeyTab: e })}>
            <TabPane tab='Основная информация' key='1'>
              {!isCreateForm &&
              <FormItem label='Токен' className='seller-token' {...formItemLayout}>
                {this.props.formFieldValues && this.props.formFieldValues.s_token.value}
              </FormItem>
                            }
              <FormItem label='Название' {...formItemLayout}>
                {getFieldDecorator('s_name', {
                                    rules: [
                                        { required: true, message: 'Пожалуйста введите название.' },
                                        { max: 50, message: 'Максимальная длина имени 50 символов' },
                                    ],
                                })(<Input placeholder='Название' />)}
              </FormItem>
              {!!paramList && !!paramList.kassa &&
              <FormItem label='Тип кассы' {...formItemLayout}>
                {getFieldDecorator('f_kassa_type', {
                                        initialValue: 1,
                                        rules: [{ required: true, message: 'Пожалуйта укажите тип' }],
                                    })(<Radio.Group>
                                      {paramList.kassa.map(item =>
                                        <Radio.Button key={item.id} value={item.id}>{item.name}</Radio.Button>)}
                                    </Radio.Group>)}
              </FormItem>
                            }
              {!!paramList && !!paramList.currency &&
              <FormItem label='Валюта' {...formItemLayout}>
                {getFieldDecorator('f_currency_type', {
                                        initialValue: 1,
                                        rules: [{
                                            required: true,
                                            message: 'Пожалуйта укажите тип валюты',
                                        }],
                                    })(<Radio.Group>
                                      {paramList.currency.map(item =>
                                            (<Radio.Button
                                              key={item.id}
                                              value={item.id}
                                            >{item.name[0].toUpperCase() + item.name.slice(1)}
                                            </Radio.Button>))}
                                    </Radio.Group>)}
              </FormItem>
                            }
              { paramList && paramList.currency &&
              <FormItem
                {...formItemLayout}
                label={
                  <span style={{
                    overflowWrap: 'break-word',
                    whiteSpace: 'normal',
                  }}>
                    Коэффициент конвертации бонусов <Tooltip
                      placement='top'
                      title='Настройка позволит тратить клиентам бонусы не в соотношении 1 бонус = 1 рубль, а введенное число = 1 рубль. То есть если ввести число 10, то будет 10 бонусов = 1 рубль'
                    >
                      <Icon type='question-circle' />
                    </Tooltip>
                  </span>
                      }
              >
                {getFieldDecorator('n_convertation_coef', {
                    initialValue: 1,
                    rules: [{
                      required: true,
                      message: 'Пожалуйта коэффицент ковертации',
                    }],
                  })(<InputNumber
                    min={0}
                    step={0.1}
                  />)}
              </FormItem>
              }
              <FormItem label='Адрес' {...formItemLayout}>
                {getFieldDecorator('s_address', {
                                    rules: [{ required: true, message: 'Пожалуйста введите адрес.' }],
                                })(<TextArea rows={3} placeholder='Адрес' />)}
              </FormItem>
              <FormItem label='Разрешенные префиксы' {...formItemLayout}>
                {getFieldDecorator('s_available_prefixes', {
                  initialValue: [],
                  rules: [{ required: true, message: 'Пожалуйста выбирите префиксы.' }],
                })(<PhonePrefixMultiselect />)}
              </FormItem>
              <FormItem label='Телефон' {...formItemLayout}>
                {getFieldDecorator('s_phone', {
                                    initialValue: {
                                        number: '',
                                        country: {},
                                        prefix: '',
                                    },
                                    rules: [{
                                        required: true,
                                        message: 'Не валидный номер телефона',
                                        // validator: (rule, value, callback) => {
                                        //     if (isMobilePhone(value.number, value.country.countryCode)) {
                                        //         this.setState({
                                        //           ...this.state,
                                        //           errorPhoneNumber: false,
                                        //         })
                                        //         return callback()
                                        //     }
                                        //   this.setState({
                                        //     ...this.state,
                                        //     errorPhoneNumber: true,
                                        //   })
                                        //     callback('Не валидный номер телефона')
                                        // },
                                    }],
                                })(<PhoneInputComponent error={this.state.errorPhoneNumber} />)}
              </FormItem>
              <FormItem label='Процент списания' {...formItemLayout}>
                {getFieldDecorator('n_bonus_percent', {
                                    rules: [{ required: true, message: 'Пожалуйста введите процент списания бонусов.' }],
                                })(<InputNumber
                                  style={{ width: '100%' }}
                                  placeholder='Процент списания'
                                  min={0}
                                  max={100}
                                  step={0.5}
                                />)}
              </FormItem>
              <FormItem label='Emails' {...formItemLayout}>
                {getFieldDecorator('s_feedback', {
                                    initialValue: 'you_mail@mail.ru',
                                    rules: [{ required: false, message: 'Пожалуйста укажите Email.' }],
                                })(<Input placeholder='Email' />)}
              </FormItem>
              <FormItem label='Сайт' {...formItemLayout}>
                {getFieldDecorator('s_site', {
                                    rules: [{ required: false, type: 'url', message: 'Пожалуйста введите адрес сайта.' }],
                                })(<Input placeholder='Сайт' />)}
              </FormItem>
              <FormItem label='Лимит баланса' {...formItemLayout}>
                {getFieldDecorator('n_balance_limit', {
                                    initialValue: 0,
                                    rules: [{
                                        required: true,
                                        message: 'Пожалуйста введите лимит баланса для отправки смс.',
                                    }],
                                })(<InputNumber
                                  style={{ width: '100%' }}
                                  placeholder='Лимит баланса'
                                  min={-100000}
                                  max={10000}
                                  step={0.5}
                                />)}
              </FormItem>
              <FormItem label='Тип процессинга' {...formItemLayout}>
                {getFieldDecorator('n_processing_type', {
                                    initialValue: 1,
                                    rules: [{ required: true, message: 'Пожалуйта укажите тип процессинга' }],
                                })(<Radio.Group>
                                  <Radio.Button key={1} value={1}>v1</Radio.Button>
                                  <Radio.Button key={2} value={2}>v1.5</Radio.Button>
                                </Radio.Group>)}
              </FormItem>
              <FormItem label='Исключить из расчета биллинга СМС' {...formItemLayout}>
                {getFieldDecorator('n_disable_billing', {
                                    valuePropName: 'checked',
                                    rules: [{ required: false, message: 'Исключить из расчета биллинга СМС.' }],
                                })(<Switch />)}
              </FormItem>
              <FormItem label='Использовать СМС отправку' {...formItemLayout}>
                {getFieldDecorator('is_enable_sms', {
                                    valuePropName: 'checked',
                                    rules: [{ required: false, message: 'Исключить из расчета биллинга СМС.' }],
                                })(<Switch />)}
              </FormItem>
              <FormItem label='Блокировка' {...formItemLayout}>
                {getFieldDecorator('n_disable', {
                                    valuePropName: 'checked',
                                    rules: [{ required: false, message: 'Блокировка.' }],
                                })(<Switch />)}
              </FormItem>

              {(this.props.formFieldValues && this.props.formFieldValues.f_kassa_type && (this.props.formFieldValues.f_kassa_type.value === 3 || this.props.formFieldValues.f_kassa_type.value === 5)) &&
              <div>
                <div style={{ borderBottom: '1px solid #E9E9E9' }} />
                <br />
                <FormItem label='Периодичность выгрузки' {...formItemLayout}>
                  {getFieldDecorator('n_mts_exchange_minutes', {
                                            rules: [{
                                                required: false,
                                                message: 'Укажите периодичность выгрузки в минутах.',
                                            }],
                                        })(<InputNumber
                                          style={{ width: '100%' }}
                                          placeholder='Периодичность выгрузки в минутах'
                                          min={0}
                                          max={600}
                                          step={1}
                                        />)}
                </FormItem>
                {this.props.formFieldValues.f_kassa_type.value === 3 &&
                  <FormItem label='МТС токен' {...formItemLayout}>
                    {getFieldDecorator('s_mts_token', {
                                              rules: [{ required: false, message: 'Укажите МТС токен.' }],
                                          })(<Input placeholder='МТС токен' />)}
                    {getFieldDecorator('n_mts_env', {
                                              valuePropName: 'checked',
                                              rules: [{ required: false, message: 'Укажите параметр.' }],
                                          })(<Switch checkedChildren='prod' unCheckedChildren='dev' />)}
                  </FormItem>
                }
              </div>
                            }
            </TabPane>
            <TabPane tab='Настройка чат-бота' key='2'>
              <FormItem label='Видимость кнопки «Подарить бонусы»' {...formItemLayout}>
                {getFieldDecorator('n_transfer', {
                                    valuePropName: 'checked',
                                    rules: [{ required: false, message: 'Видимость.' }],
                                })(<Switch
                                  checkedChildren={<Icon type='eye' />}
                                  unCheckedChildren={<Icon type='eye-invisible' />}
                                />)}
              </FormItem>
              <FormItem label='Видимость кнопки «Добавить карту»' {...formItemLayout}>
                {getFieldDecorator('n_cardsupport', {
                                    valuePropName: 'checked',
                                    rules: [{ required: false, message: 'Добавить карту.' }],
                                })(<Switch
                                  checkedChildren={<Icon type='eye' />}
                                  unCheckedChildren={<Icon type='eye-invisible' />}
                                />)}
              </FormItem>
              <FormItem label='Видимость кнопки «Промокод»' {...formItemLayout}>
                {getFieldDecorator('n_promocode', {
                                    valuePropName: 'checked',
                                    rules: [{ required: false, message: 'Промокод.' }],
                                })(<Switch
                                  checkedChildren={<Icon type='eye' />}
                                  unCheckedChildren={<Icon type='eye-invisible' />}
                                />)}
              </FormItem>
              <FormItem label='Видимость кнопки «Реф. ссылка»' {...formItemLayout}>
                {getFieldDecorator('n_referral_link', {
                                    valuePropName: 'checked',
                                    rules: [{ required: false, message: 'Реферальная ссылка.' }],
                                })(<Switch
                                  checkedChildren={<Icon type='eye' />}
                                  unCheckedChildren={<Icon type='eye-invisible' />}
                                />)}
              </FormItem>
              <FormItem label='Токен чат-бота' {...formItemLayout}>
                {getFieldDecorator('s_chatbot_token', {
                                    rules: [{ required: false, message: 'Укажите токен чат-бота.' }],
                                })(<TextArea rows={3} placeholder='Токен чат-бота' />)}
              </FormItem>
            </TabPane>
            <TabPane tab='Настройка ИИ' key='3'>
              <FormItem label='Промт для аналитики клиента' {...formItemLayout}>
                {getFieldDecorator('s_prompt_client', {
                                    rules: [{ required: false, message: 'Укажите промт.' }],
                                })(<TextArea rows={3} placeholder='Промт' />)}
              </FormItem>
              <FormItem label='Промт для аналитики торговой сети' {...formItemLayout}>
                {getFieldDecorator('s_prompt_seller', {
                                    rules: [{ required: false, message: 'Укажите промт.' }],
                                })(<TextArea rows={3} placeholder='Промт' />)}
              </FormItem>

              <FormItem label='Промт для автоответа клиенту' {...formItemLayout}>
                {getFieldDecorator('s_prompt_feedback', {
                                    rules: [{ required: false, message: 'Укажите промт.' }],
                                })(<TextArea rows={3} placeholder='Промт' />)}
              </FormItem>

              <FormItem label='Промт для автоответа в НИОКР' {...formItemLayout}>
                {getFieldDecorator('s_prompt_niokr', {
                                    rules: [{ required: false, message: 'Укажите промт.' }],
                                })(<TextArea rows={3} placeholder='Промт' />)}
              </FormItem>

              <FormItem label='Промт для аналитики причин негативных оценок' {...formItemLayout}>
                {getFieldDecorator('s_prompt_negative_rating', {
                                    rules: [{ required: false, message: 'Укажите промт.' }],
                                })(<TextArea rows={3} placeholder='Промт' />)}
              </FormItem>
            </TabPane>
          </Tabs>
                    :
          <div>
            {!isCreateForm &&
            <FormItem label='Токен' className='seller-token' {...formItemLayout}>
              {this.props.formFieldValues && this.props.formFieldValues.s_token.value}
            </FormItem>
                        }
            <FormItem label='Название' {...formItemLayout}>
              {getFieldDecorator('s_name', {
                                rules: [{ required: true, message: 'Пожалуйста введите название.' }],
                            })(<Input placeholder='Название' />)}
            </FormItem>
            {!isCreateForm &&
            <div>
              <FormItem label='Адрес' {...formItemLayout}>
                {getFieldDecorator('s_address', {
                                        rules: [{ required: true, message: 'Пожалуйста введите адрес.' }],
                                    })(<TextArea rows={3} placeholder='Адрес' />)}
              </FormItem>
              <FormItem label='Телефон' {...formItemLayout}>
                {getFieldDecorator('s_phone', {
                                    initialValue: {
                                        number: '',
                                        country: {},
                                        prefix: '',
                                    },
                                    rules: [{
                                        required: true,
                                        message: 'Не валидный номер телефона',
                                        // validator: (rule, value, callback) => {
                                        //     if (isMobilePhone(value.number, value.country.countryCode)) {
                                        //         this.setState({
                                        //           ...this.state,
                                        //           errorPhoneNumber: false,
                                        //         })
                                        //         return callback()
                                        //     }
                                        //   this.setState({
                                        //     ...this.state,
                                        //     errorPhoneNumber: true,
                                        //   })
                                        //     callback('Не валидный номер телефона')
                                        // },
                                    }],
                                })(<PhoneInputComponent error={this.state.errorPhoneNumber} />)}
              </FormItem>
            </div>
                        }
            <FormItem label='Исключить из расчета биллинга СМС' {...formItemLayout}>
              {getFieldDecorator('n_disable_billing', {
                                  valuePropName: 'checked',
                                  rules: [{ required: false, message: 'Исключить из расчета биллинга СМС.' }],
                              })(<Switch />)}
            </FormItem>
            <FormItem label='Использовать СМС отправку' {...formItemLayout}>
                {getFieldDecorator('is_enable_sms', {
                                    valuePropName: 'checked',
                                    rules: [{ required: false, message: 'Исключить из расчета биллинга СМС.' }],
                                })(<Switch />)}
              </FormItem>
            <FormItem label='Блокировка' {...formItemLayout}>
              {getFieldDecorator('n_disable', {
                                valuePropName: 'checked',
                                rules: [{ required: false, message: 'Блокировка.' }],
                            })(<Switch />)}
            </FormItem>
            <div style={{ borderBottom: '1px solid #E9E9E9' }} />
            <br />
            {!isCreateForm &&
            <FormItem label='Периодичность выгрузки' {...formItemLayout}>
              {getFieldDecorator('n_mts_exchange_minutes', {
                                    rules: [{ required: false, message: 'Укажите периодичность выгрузки в минутах.' }],
                                })(<InputNumber
                                  style={{ width: '100%' }}
                                  placeholder='Периодичность выгрузки в минутах'
                                  min={0}
                                  max={600}
                                  step={1}
                                />)}
            </FormItem>
                        }
            <FormItem label='МТС токен' {...formItemLayout}>
              {getFieldDecorator('s_mts_token', {
                                rules: [{ required: false, message: 'Укажите МТС токен.' }],
                            })(<Input placeholder='МТС токен' />)}
              {getFieldDecorator('n_mts_env', {
                                initialValue: false,
                                valuePropName: 'checked',
                                rules: [{ required: false, message: 'Укажите параметр.' }],
                            })(<Switch checkedChildren='prod' disabled unCheckedChildren='dev' />)}
            </FormItem>
          </div>
                }
        <FormItem {...tailFormItemLayout}>
          <Button
            loading={this.props.isCreateItemLoading || this.props.isEditItemLoading}
            type='primary'
            htmlType='submit'
            style={{ marginRight: '12px' }}
          >
            {isCreateForm ? 'Создать' : 'Сохранить'}
          </Button>
          {
                        !isCreateForm && this.state.activeKeyTab === '1' &&
                        <Button
                          loading={this.props.isDeleteItemLoading}
                          type='danger'
                          htmlType='button'
                          onClick={this.handleOnDelete}
                        >
                          Удалить
                        </Button>
                    }
        </FormItem>
      </Form>
    )
  }
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onFieldsChange(changedFields)
  },
  mapPropsToFields(props) {
    const { formFieldValues = {} } = props
    return {
      s_name: Form.createFormField(formFieldValues.s_name),
      s_feedback: Form.createFormField(formFieldValues.s_feedback),
      s_address: Form.createFormField(formFieldValues.s_address),
      s_phone: Form.createFormField(formFieldValues.s_phone),
      s_site: Form.createFormField(formFieldValues.s_site),
      s_chatbot_token: Form.createFormField(formFieldValues.s_chatbot_token),
      n_bonus_percent: Form.createFormField(formFieldValues.n_bonus_percent),
      n_disable: Form.createFormField(formFieldValues.n_disable),
      n_disable_billing: Form.createFormField(formFieldValues.n_disable_billing),
      is_enable_sms: Form.createFormField(formFieldValues.is_enable_sms),
      n_mts_env: Form.createFormField(formFieldValues.n_mts_env),
      s_mts_token: Form.createFormField(formFieldValues.s_mts_token),
      s_token: Form.createFormField(formFieldValues.s_token),
      f_kassa_type: Form.createFormField(formFieldValues.f_kassa_type),
      n_processing_type: Form.createFormField(formFieldValues.n_processing_type),
      f_currency_type: Form.createFormField(formFieldValues.f_currency_type),
      n_mts_exchange_minutes: Form.createFormField(formFieldValues.n_mts_exchange_minutes),
      n_transfer: Form.createFormField(formFieldValues.n_transfer),
      n_cardsupport: Form.createFormField(formFieldValues.n_cardsupport),
      n_balance_limit: Form.createFormField(formFieldValues.n_balance_limit),
      s_available_prefixes: Form.createFormField(formFieldValues.s_available_prefixes),
      n_convertation_coef: Form.createFormField(formFieldValues.n_convertation_coef),
      n_promocode: Form.createFormField(formFieldValues.n_promocode),
      n_referral_link: Form.createFormField(formFieldValues.n_referral_link),
      s_prompt_client: Form.createFormField(formFieldValues.s_prompt_client),
      s_prompt_seller: Form.createFormField(formFieldValues.s_prompt_seller),
      s_prompt_feedback: Form.createFormField(formFieldValues.s_prompt_feedback),
      s_prompt_niokr: Form.createFormField(formFieldValues.s_prompt_niokr),
      s_prompt_negative_rating: Form.createFormField(formFieldValues.s_prompt_negative_rating),
    }
  },
})(ItemForm)

export default CustomizedForm



// WEBPACK FOOTER //
// src/containers/SellerForm/Form.jsx